import { Injectable } from "@angular/core";
import { log } from "src/app/common/logger";
import { Facility } from "../backend/models/facility";

const logger = log("FacilityService");

@Injectable()
export class FacilityService {
  private currentFacility: any | null = null;

  setCurrent(facility: Facility): void {
    logger.info(
      `current facility: "${facility.businessName}" - ${facility.uuid} - ${facility.practiceUuid}`
    );
    this.currentFacility = facility;
  }

  getCurrent(): Facility | null {
    return this.currentFacility;
  }

  clear(): void {
    this.currentFacility = null;
  }
}
